<template>
  <v-container fluid>
    <v-layout row wrap mt-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          :rules="[rules.LicenseTypeRequired]"
          required
          v-model="Licensure.LicenseType"
          label="License Type"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 md4 pr-4>
        <v-text-field
          :rules="[rules.LicenseNumberRequired]"
          v-model="Licensure.LicenseNumber"
          required
          label="Number"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>

      <v-flex xs12 md4>
        <v-text-field
          :rules="[rules.DisciplineOrSpecialtyRequired]"
          required
          v-model="Licensure.DisciplineOrSpecialty"
          label="Discipline/Specialty:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <date-picker
          label="Original License Date"
          v-model="Licensure.OriginalLicenseDate"
          :rules="[rules.OriginalLicenseDateRequired,rules.LicenseDateCheck(Licensure.OriginalLicenseDate, Licensure.LicenseExpirationDate)]"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>
      <v-flex xs12 md6>
        <date-picker
          label="License Expiration Date"
          v-model="Licensure.LicenseExpirationDate"
          :rules="[rules.LicenseExpirationDateRequired,rules.LicenseDateCheck(Licensure.OriginalLicenseDate, Licensure.LicenseExpirationDate)]"
          :disabled="disableFields"
        ></date-picker>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md6 pr-4>
        <v-text-field
          required
          :rules="[rules.RestrictionsRequired]"
          v-model="Licensure.Restrictions"
          label="Restrictions:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field
          required
          :rules="[rules.LicensingAgencyOfBoardRequired]"
          v-model="Licensure.LicensingAgencyOfBoard"
          label="Licensing Agency or Board:"
          :readonly="disableFields"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 pt-4>
         <v-radio-group          
          required
          row
          v-model="Licensure.AreyouCurrentlyLicensedinWy"
          label="Are You Currently Licensed In Wyoming"
          :readonly="disableFields"
        >
          <v-radio label="Yes" :value="true"></v-radio>
          <v-radio label="No" :value="false"></v-radio>
        </v-radio-group>        
         </v-flex>
        </v-layout>
    
    <v-layout row wrap>
      <v-flex xs12 pt-4 v-if="Licensure.AreyouCurrentlyLicensedinWy == false">
        <v-textarea
          :rules="[rules.NotLicensedequired]"
          name="input-7-1"
          required
          label="If not currently licensed in Wyoming, when will Wyoming licensure be obtained?"
          v-model="Licensure.IfNoCurrentlyLicensedWhenWYLicensureObtained"
          :readonly="disableFields"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Rules from '../validation/rules'
import DatePickerVue from './DatePicker.vue';
export default {
  name: 'Licensure',
  props: {
    Licensure: Object,
    disableFields: Boolean
  },
  data() {
    return {
      menu: false,
      menu2: false,
      rules: Rules,
    }
  },
  methods: {},

  components: {
    'date-picker' : DatePickerVue
  },
  watch: {
    Licensure: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
}
</script>
<style>

</style>